import { mapState } from 'vuex';
import ApiService from '../../../services/apiService';
import { getTimeArrayFromRangeKey } from '../dateTime/pickerParseRangeValues.js';
import get from 'lodash/get';
const AGGREGATE_FUNCTIONS = {
  ALL: 'ALL',
  LAST: 'LAST',
  SUM: 'SUM',
  MAX: 'MAX',
  AVG: 'AVG'
};
const AGGREGATE_PERIOD = {
  hourly: 'hourly',
  daily: 'daily',
  weekly: 'weekly'
};
export default {
  name: 'CoreCsvExportDialogMulti',
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'digitalTwin'
    }
  },
  data: function () {
    return {
      name: null,
      accountId: null,
      parentId: null,
      parentScopeId: null,
      filter: [],
      filterType: this.type,
      dateFrom: null,
      dateTo: null,
      searchTotalCount: null,
      dataAggregationObj: {
        functionName: AGGREGATE_FUNCTIONS.ALL,
        aggregatePeriod: null
      },
      search: [],
      searchOperator: 'AND',
      showStructureSection: false,
      allDriversVariables: [],
      selectedDriversVariables: [],
      stateIdentifiers: [],
      customProperties: [],
      references: [],
      drivers: [],
      selectedStates: [],
      stateIdSearchInput: null,
      csvOptions: {
        headers: [],
        includeHeaders: true,
        clusterPerPacket: false
      }
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'color']),
    formIsValid() {
      return Boolean(this.name) && Boolean(this.accountId);
    },
    dataAggregationItems() {
      const stateIdentifiersContainsNonAggregatableTypes = !this.selectedStates.length && this.stateIdentifiers.some(si => ['string', 'json'].includes(si.valueType));
      const selectedStatesContainsNonAggregatableTypes = this.selectedStates.some(ss => ['string', 'json'].includes(ss.split('-').pop()));
      const selectionContainsStringJsonTranslatedText = this.$i18n_t('BackgroundJobs.ScheduledExports.dialog.dataAggregation.selectionContainsStringJson');
      const isAggregateDisabled = stateIdentifiersContainsNonAggregatableTypes || selectedStatesContainsNonAggregatableTypes || this.csvOptions.clusterPerPacket;
      let aggregateOptions = [{
        text: this.$i18n_t('BackgroundJobs.ScheduledExports.dialog.dataAggregation.ALL'),
        value: {
          functionName: AGGREGATE_FUNCTIONS.ALL,
          aggregatePeriod: null
        }
      }, {
        text: this.$i18n_t('BackgroundJobs.ScheduledExports.dialog.dataAggregation.LAST'),
        value: {
          functionName: AGGREGATE_FUNCTIONS.LAST,
          aggregatePeriod: null
        }
      }, {
        text: `${this.$i18n_t('BackgroundJobs.ScheduledExports.dialog.dataAggregation.MAX')}
            ${selectedStatesContainsNonAggregatableTypes || stateIdentifiersContainsNonAggregatableTypes ? `(${selectionContainsStringJsonTranslatedText})` : ''}
          `,
        value: {
          functionName: AGGREGATE_FUNCTIONS.MAX,
          aggregatePeriod: null
        },
        disabled: isAggregateDisabled
      }, {
        text: `${this.$i18n_t('BackgroundJobs.ScheduledExports.dialog.dataAggregation.SUM')}
            ${selectedStatesContainsNonAggregatableTypes || stateIdentifiersContainsNonAggregatableTypes ? `(${selectionContainsStringJsonTranslatedText})` : ''}
          `,
        value: {
          functionName: AGGREGATE_FUNCTIONS.SUM,
          aggregatePeriod: null
        },
        disabled: isAggregateDisabled
      }, {
        text: `${this.$i18n_t('BackgroundJobs.ScheduledExports.dialog.dataAggregation.AVG-hourly')}
            ${selectedStatesContainsNonAggregatableTypes || stateIdentifiersContainsNonAggregatableTypes ? `(${selectionContainsStringJsonTranslatedText})` : ''}
          `,
        value: {
          functionName: AGGREGATE_FUNCTIONS.AVG,
          aggregatePeriod: AGGREGATE_PERIOD.hourly
        },
        disabled: isAggregateDisabled
      }, {
        text: `${this.$i18n_t('BackgroundJobs.ScheduledExports.dialog.dataAggregation.AVG-daily')}
            ${selectedStatesContainsNonAggregatableTypes || stateIdentifiersContainsNonAggregatableTypes ? `(${selectionContainsStringJsonTranslatedText})` : ''}
          `,
        value: {
          functionName: AGGREGATE_FUNCTIONS.AVG,
          aggregatePeriod: AGGREGATE_PERIOD.daily
        },
        disabled: isAggregateDisabled
      }, {
        text: `${this.$i18n_t('BackgroundJobs.ScheduledExports.dialog.dataAggregation.AVG-weekly')}
            ${selectedStatesContainsNonAggregatableTypes || stateIdentifiersContainsNonAggregatableTypes ? `(${selectionContainsStringJsonTranslatedText})` : ''}
          `,
        value: {
          functionName: AGGREGATE_FUNCTIONS.AVG,
          aggregatePeriod: AGGREGATE_PERIOD.weekly
        },
        disabled: isAggregateDisabled
      }];
      return aggregateOptions;
    },
    searchTotalCountMessage() {
      if (this.searchTotalCount === null || this.searchTotalCount === undefined || (this.filter || []).length === 0) {
        return null;
      }
      const typeDevice = this.filterType === 'digitalTwin' ? this.$i18n_t('BackgroundJobs.ScheduledExports.dialog.data.digitalTwins') : this.$i18n_t('BackgroundJobs.ScheduledExports.dialog.data.virtualDevices');
      if (this.searchTotalCount === -1) {
        return this.$i18n_t('BackgroundJobs.ScheduledExports.dialog.data.totalCountError', {
          devices: typeDevice
        });
      }
      return this.$i18n_t('BackgroundJobs.ScheduledExports.dialog.data.totalCount', {
        count: this.searchTotalCount,
        devices: typeDevice
      });
    }
  },
  watch: {
    isOpen() {
      if (this.isOpen) {
        this.name = null;
        this.accountId = null;
        this.filter = null;
        this.initRange();
      }
    },
    filterType(newVal) {
      this.showStructureSection = newVal !== 'digitalTwin';
    },
    drivers() {
      this.populateDrivers();
    },
    accountId(newVal, oldVal) {
      if (newVal !== oldVal) {
        ApiService.digitalTwinFetchChildren(this, null, 0, 1, null, ['bare'], false, newVal).then(res => {
          this.parentId = get(res, 'digitaltwins[0].id', null);
        }).catch(() => this.$snack(this.$i18n_t('Common.digitalTwins.errorFindingDTwins'), 'error'));
        this.fetchFilterDeviceCount(this.filterType, this.filter);
      }
    },
    parentId(parentId) {
      ApiService.digitalTwinGet(this, parentId).then(twin => {
        this.parentScopeId = twin.scopeId;
        this.fetchFilterDeviceCount(this.filterType, this.filter, this.filterOperator);
      }).catch(error => {
        console.error(error);
      });
    },
    selectedStates(newSelectedStates) {
      const statesHaveNotAggregateableType = newSelectedStates.some(state => ['string', 'json'].includes(state.split('-').pop()));
      const isAggregateFunctionSelected = [AGGREGATE_FUNCTIONS.SUM, AGGREGATE_FUNCTIONS.MAX, AGGREGATE_FUNCTIONS.AVG].includes(this.dataAggregationObj.functionName);
      if (statesHaveNotAggregateableType && isAggregateFunctionSelected) {
        this.dataAggregationObj = {
          functionName: AGGREGATE_FUNCTIONS.ALL,
          aggregatePeriod: null
        };
      }
    },
    'csvOptions.clusterPerPacket': {
      handler(newValue) {
        if (!newValue) {
          // clear selected drivers variables when clusterPerPacket is disabled
          this.selectedDriversVariables = [];
        }
      },
      immediate: true
    }
  },
  mounted() {
    this.showStructureSection = this.filterType !== 'digitalTwin';
  },
  methods: {
    initRange() {
      const range = getTimeArrayFromRangeKey('now-24h');
      this.dateFrom = range[0];
      this.dateTo = range[1];
    },
    updateTimeRange(ev) {
      this.dateFrom = ev.from;
      this.dateTo = ev.to;
    },
    updateFilter(search, operator) {
      this.filter = search;
      this.filterOperator = operator;
      this.fetchFilterDeviceCount(this.filterType, this.filter, this.filterOperator);
    },
    fetchFilterDeviceCount(type, filter, operator) {
      const searchItems = (filter || []).map(item => ({
        variable: item.param,
        // support item.search.value === null, so do not simply have a >search.value || search< expression
        search: (item.search || {}).value === undefined ? item.search : item.search.value,
        key: item.key
      }));
      const reqFilters = this.accountId ? [{
        type: 'tenantIds',
        ids: [this.accountId]
      }] : [];
      reqFilters.push({
        type: 'scopeIds',
        ids: [this.parentScopeId].filter(v => v != null)
      });
      if (searchItems.length === 0) {
        // if there are no search items, in case the search filter was emptied, reset the total count
        // and return. do not search for all available devices.
        this.searchTotalCount = null;
        this.allDriversVariables = [];
        this.stateIdentifiers = [];
        this.customProperties = [];
        this.references = [];
        this.drivers = [];
        this.selectedStates = [];
        return;
      }
      const apiMethod = type === 'virtualDevice' ? ApiService.virtualDeviceFetch : ApiService.digitalTwinsFetch;
      const apiParams = [this,
      // context
      null,
      // userId
      [],
      // scopeIds
      reqFilters,
      // filters
      null,
      // options
      {
        variable: 'id',
        direction: 'ASC'
      },
      // orderBy
      0,
      // offset
      1,
      // limit
      searchItems];
      if (type === 'virtualDevice') {
        apiParams.push(undefined, true,
        // include identifiers
        true,
        // include properties
        true,
        // include drivers
        operator);
      } else {
        apiParams.push(true,
        // include identifiers
        true,
        // include properties
        true // include references
        );
      }
      apiMethod(...apiParams).then(result => {
        this.searchTotalCount = result.totalCount;
        this.stateIdentifiers = (result.identifiers || []).sort((a, b) => a.key.localeCompare(b.key, undefined, {
          numeric: true
        }));
        this.customProperties = (result.properties || []).sort((a, b) => a.keyValue.localeCompare(b.keyValue, undefined, {
          numeric: true
        }));
        if (type === 'digitalTwin') {
          this.references = result.references.sort((a, b) => a.key.localeCompare(b.key));
        }
        this.drivers = result.drivers || [];
        this.selectedStates = [];
      }).catch(error => {
        console.error(error);
        this.searchTotalCount = -1;
        this.allDriversVariables = [];
        this.stateIdentifiers = [];
        this.customProperties = [];
        this.references = [];
        this.drivers = [];
        this.selectedStates = [];
      });
    },
    handleSave() {
      const searchItems = (this.filter || []).map(item => ({
        variable: item.param,
        // support item.search.value === null, so do not simply have a >search.value || search< expression
        search: (item.search || {}).value === undefined ? item.search : item.search.value,
        key: item.key
      }));
      const data = {
        title: this.name,
        type: this.filterType,
        tenantId: this.accountId,
        parentId: this.parentId,
        search_items: JSON.parse(JSON.stringify(searchItems)),
        fromTime: new Date(this.dateFrom * 1000).toISOString(),
        toTime: new Date(this.dateTo * 1000).toISOString(),
        search_operator: this.searchOperator,
        stateIdentifiers: this.selectedStates,
        aggregateFunction: this.dataAggregationObj.functionName,
        aggregatePeriod: this.dataAggregationObj.aggregatePeriod,
        csvOptions: this.csvOptions.includeHeaders ? {
          headers: this.csvOptions.headers.map(c => {
            return {
              name: c.name,
              mappedValue: c.mappedValue,
              isCustomProperty: c.isCustomProperty,
              isReferenceProperty: c.isReferenceProperty,
              isInParsedState: c.isInParsedState
            };
          }),
          includeHeaders: true,
          clusterPerPacket: this.csvOptions.clusterPerPacket
        } : {
          includeHeaders: false
        }
      };
      ApiService.createBackgroundRunnerBulkExportDeviceStates(data).then(() => {
        this.$snack(this.$i18n_t('BackgroundJobs.ScheduledExports.snacks.runSuccess'), 'success');
      }).catch(error => {
        console.error(error);
        this.$snack(this.$i18n_t('BackgroundJobs.ScheduledExports.snacks.runError'), 'error');
      }).finally(() => {
        this.close();
      });
    },
    resetDialog() {
      this.searchTotalCount = null;
      this.name = null;
      this.accountId = null;
      this.filter = [];
      this.filterType = this.type;
      this.dateFrom = null;
      this.dateTo = null;
      this.dataAggregationObj = {
        functionName: AGGREGATE_FUNCTIONS.ALL,
        aggregatePeriod: null
      };
      this.searchOperator = 'AND';
      this.searchItems = [];
      this.search = [];
      this.stateIdentifiers = [];
      this.customProperties = [];
      this.references = [];
      this.drivers = [];
      this.selectedStates = [];
      this.csvOptions = {
        headers: [],
        includeHeaders: true,
        clusterPerPacket: false
      };
    },
    close() {
      this.resetDialog();
      this.$emit('close');
    },
    populateDrivers() {
      this.allDriversVariables = [];
      const driversLatestVersionVariables = this.drivers.map(d => {
        let latestVersionNumber = 0; // default
        let latestVersion = null;
        if (Array.isArray(d.versions)) {
          d.versions.forEach(dv => {
            if (dv.version === 'default') {
              if (latestVersionNumber === 0) {
                latestVersion = dv;
              }
              return;
            }
            if (dv.version > latestVersionNumber) {
              latestVersionNumber = dv.version;
              latestVersion = dv;
            }
          });
        }
        if (latestVersion && latestVersion.parser) {
          return latestVersion.parser.config.variables;
        }
      });
      const tmp = {};
      driversLatestVersionVariables.forEach(variable => {
        if (variable) {
          Object.keys(variable).forEach(variableKey => {
            if (!tmp[variableKey]) {
              tmp[variableKey] = 0;
            }
            tmp[variableKey]++;
          });
        }
      });
      Object.keys(tmp).forEach(variableKey => {
        this.allDriversVariables.push({
          title: variableKey,
          count: tmp[variableKey]
        });
      });
    }
  }
};